import { render, staticRenderFns } from "./SignPadDialog.vue?vue&type=template&id=23ba04e6&scoped=true&"
import script from "./SignPadDialog.vue?vue&type=script&lang=js&"
export * from "./SignPadDialog.vue?vue&type=script&lang=js&"
import style0 from "./SignPadDialog.vue?vue&type=style&index=0&id=23ba04e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ba04e6",
  null
  
)

export default component.exports